import type {LinkedDocument} from '@/types/documentLinking';
import type {MondayItem} from '@/types/monday/mondayItem';

import {BoardNames, getBoardConfigurationByName, getBoardIdByName} from './config';
import {getCollection} from '@/lib/filters/filters';
import {DisplayField} from '@/lib/classes/InfoWindowContent';

type LinkedItem = {
  name: string;
  boardUrl: string;
  displayFields: DisplayField[];
  // TODO: BMAPS-3342 - delete this property when deleting LinkedDocumentsDisplay.vue
  nameClickHandler: () => void;
};

/**
 * Returns an array of items ready to be displayed as linked documents in the UI for a specific board.
 * @param name The name of the board for which to get linked items.
 * @param linkedDocuments An array of linked documents that may or may not contain items for the specified board.
 */
async function getLinkedItemsForBoard(name: BoardNames, linkedDocuments: LinkedDocument[]): Promise<LinkedItem> {
  const config = await getBoardConfigurationByName(name);
  const boardId = await getBoardIdByName(name);

  // We collect all display fields (one from each linked item) to display together in one section.
  const displayFields: DisplayField[] = [];
  const mondayItemsCol = getCollection('mondayItems');

  for (const doc of linkedDocuments) {
    const item = mondayItemsCol.getItem(doc.id) as MondayItem;
    if (!item) {
      console.warn(`No Monday item found for linked document with ID: ${doc.id}`);
      continue;
    }

    if (item.parentSection !== config.sectionName || !item.displayFields || !item.displayFields.length) continue;

    // Currently, we are displaying one field per linked Monday.com item, and it will always be the first field.
    displayFields.push(new DisplayField(item.displayFields[0]));
  }

  return {
    name: config.sectionName,
    // TODO: BMAPS-3342 - delete this property when deleting LinkedDocumentsDisplay.vue
    nameClickHandler: () => {
      window.open(`https://northpointkc.monday.com/boards/${boardId}`, '_blank');
    },
    boardUrl: `https://northpointkc.monday.com/boards/${boardId}`,
    displayFields,
  };
}

export {
  getLinkedItemsForBoard,
};
